export default "__VITE_ASSET__YIPBOxhe__"